export const behindTheMask = {
  type: 'screen',
  color: '#5E51F0',
  bgcolor: '#292746',
  eventType: {
    ru: 'Корпоративный бал',
    en: '"Behind the mask" corporate ball'
  },
  title: {
    ru: 'Behind the mask'
  },
  link: 'behind-the-mask',
  page: {
    image: '02-main-photo-min.jpg',
    meta: {
      date: {
        ru: 'ЯНВАРЬ 2019',
        en: 'JANUARY 2019'
      },
      location: {
        ru: 'Россия, Москва',
        en: 'RUSSIA, MOSCOW'
      },
      events: [],
      tags: []
    },
    intro: {
      ru: 'Как провести мероприятие в самом центре Москвы, сочетая светское настроение, современное наполнение, и дать гостям новый, вдохновляющий опыт?',
      en: 'Как провести мероприятие в самом центре Москвы, сочетая светское настроение, современное наполнение, и дать гостям новый, вдохновляющий опыт?'
    },
    video: 'https://www.youtube.com/embed/zoMU3oaXWKw?autoplay=0',
    videoImage: null,
    gradient: 'linear-gradient(150deg,#5e51f0,#ef6a3c)',
    gallery: {
      small: [],
      large: ['0201-Small-min.jpg']
    },
    gallery2: {
      small: ['0202-Small-min.jpg', '0206-Small-min.jpg'],
      large: []
    },
    gallery3: {
      small: ['0204-Small-min.jpg', '0205-Small-min.jpg'],
      large: []
    },
    content: {
      image: 'behind.png',
      text: {
        ru: '<p class="ru"><b>Мероприятие получило название Behind the mask</b> — с флёром загадочности и возможности скрыть на время свою личность, став кем угодно. Центральный арт-объект — огромная маска — стал ключевым символом заявленной темы. Эта маска состояла из множества зеркал, каждое из которых было призвано отразить разные грани личности каждого гостя.</p>',
        en: '<p class="en"><b>Мероприятие получило название Behind the mask</b> — с флёром загадочности и возможности скрыть на время свою личность, став кем угодно. Центральный арт-объект — огромная маска — стал ключевым символом заявленной темы. Эта маска состояла из множества зеркал, каждое из которых было призвано отразить разные грани личности каждого гостя.</p>',
        fz: '23'
      }
    },
    content2: {
      title: '<p class="ru">Несмотря на банкетную рассадку, пространство было организовано таким образом, что каждая его часть становилась микрозоной со своим наполнением.</p><p class="en">Несмотря на банкетную рассадку, пространство было организовано таким образом, что каждая его часть становилась микрозоной со своим наполнением.</p>',
      fzTitle: '31',
      text: '<p class="ru"><b>Шоу-номера, разделяющие акты бала, также переносили внимание зрителя в новую плоскость. Это позволяло дополнительно вовлекать участников в действо.</b></p><p class="en"><b>Шоу-номера, разделяющие акты бала, также переносили внимание зрителя в новую плоскость. Это позволяло дополнительно вовлекать участников в действо.</b></p><p class="ru">В первом акте — Behind the mask — присутствующие погружались в атмосферу вечера, наблюдая интро в исполнении профессионалов и участвуя в мастер-классе от концертмейстера.</p><p class="en">В первом акте — Behind the mask — присутствующие погружались в атмосферу вечера, наблюдая интро в исполнении профессионалов и участвуя в мастер-классе от концертмейстера.</p><p class="ru">Во втором акте — Power of mask — через шоу-номера транслировалась мысль о масках-мечтах, которые мы примеряем, пытаясь стать лучше. </p><p class="en">Во втором акте — Power of mask — через шоу-номера транслировалась мысль о масках-мечтах, которые мы примеряем, пытаясь стать лучше. </p><p class="ru">И, наконец, третья часть — Take off your mask — предлагала сбросить любые маски и просто быть собой.</p><p class="en">И, наконец, третья часть — Take off your mask — предлагала сбросить любые маски и просто быть собой.</p>',
      fzText: '16'
    },
    content3: {
      left: '<br><br><br><br><p class="block-line block-line-bottom"></p>',
      fzLeft: '19',
      right: '<p class="ru text-bold">Завершился бал выступлением актуальной звезды мировой танцевальной сцены — Уилли Уильяма.</p><p class="en  text-bold">Завершился бал выступлением актуальной звезды мировой танцевальной сцены — Уилли Уильяма.</p>',
      fzRight: '28'
    }
  }
}
